module.exports = __webpack_public_path__ + "img/start-charging-desktop-POLAND.0bd2343e.jpg";